import { FormPackagesPageRouter } from "./FormPackagesPageRouter"

export default FormPackagesPageRouter